/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "@/src/components/Container/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import Typography from "@mui/material/Typography";
import jobsSectionStyle from "@/src/components/Jobs/jobsSectionStyle";
import { Divider, Paper, Stack } from "@mui/material";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import IconCode from "@/src/assets/iconsRedesign2026/generic/toggleable/IconCode";
import Icon from "@/src/components/Icon/Icon";
import IconCivilLaw from "@/src/assets/iconsRedesign2026/civilLaw/toggleable/IconCivilLaw";
import { ArrowForward } from "@mui/icons-material";

const jobCategories = [
  {
    title: "Legal & Operations",
    icon: IconCivilLaw,
    jobs: [
      {
        title: "Teamleitung Legal Operations / Kanzleimanagement Vollzeit (m/w/d)",
        path: "/jobs/kanzleimanagement-teamleitung-mwd",
      },
      {
        title: "Rechtsanwaltsfachangestellte/r Vollzeit (m/w/d)",
        path: "/jobs/rechtsanwaltsfachangestellter-mwd",
      },
      {
        title: "Rechtsanwältin/Rechtsanwalt (m/w/d)",
        path: "/jobs/rechtsanwalt-mwd",
      },
      {
        title: "Wirtschaftsjuristin/Wirtschaftsjurist (m/w/d)",
        path: "/jobs/wirtschaftsjurist-mwd",
      },
      {
        title: "Rechtsreferendarin / Rechtsreferendar (m/w/d)",
        path: "/jobs/rechtsreferendar-mwd",
      },
    ],
  },
  {
    title: "IT & Product",
    icon: IconCode,
    jobs: [
      {
        title: "Product Manager Legal Tech (m/w/d)",
        path: "/jobs/productmanager-legaltech-mwd",
      },
      {
        title: "Senior Developer (m/w/d)",
        path: "/jobs/developer-mwd",
      },
    ],
  },
];

const JobsSection = () => {
  return (
    <Container variant={"xl"}>
      <Container variant={"xs"} sx={jobsSectionStyle.container}>
        <ChipLegalbird label={"Offene Stellen"} />
        <Typography variant={"h3"} sx={jobsSectionStyle.heading}>
          Wen wir suchen
        </Typography>
      </Container>

      <Grid container spacing={4}>
        {jobCategories.map((category) => (
          <Grid size={12} key={category.title}>
            <Stack direction={"row"} sx={jobsSectionStyle.categoryHeader} spacing={2}>
              <Icon icon={category.icon} variant={"bordered"} />
              <Typography variant={"h6"} component={"h4"}>
                {category.title}
              </Typography>
              <Divider sx={jobsSectionStyle.categoryDivider} />
            </Stack>

            {category.jobs.map((job) => (
              <Paper key={job.path} sx={jobsSectionStyle.job}>
                <Typography variant={"h6"} component={"h5"} sx={jobsSectionStyle.jobTitle}>
                  {job.title}
                </Typography>
                <Button
                  variant={"outlined"}
                  component={Link}
                  to={job.path}
                  color={"primary"}
                  endIcon={<ArrowForward />}
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  Mehr erfahren
                </Button>
              </Paper>
            ))}
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default JobsSection;
